import { useEffect, useRef, useState } from 'react'

function wolimyBezRuchu(): boolean {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true
}

/** Wyhamowanie — szybki start, miękkie dojście do wartości docelowej. */
function wyhamuj(postep: number): number {
  return 1 - (1 - postep) ** 3
}

const CZAS_MS = 420

/**
 * Prowadzi liczbę do nowej wartości zamiast przeskakiwać. Licznik, który
 * dobija do kwoty, pokazuje że coś się przeliczyło — skok wygląda jak
 * przypadkowe przerysowanie i nie niesie tej informacji.
 *
 * Przy `prefers-reduced-motion` wartość ustawia się od razu.
 */
export function useLiczbaPlynna(cel: number): number {
  const [wartosc, ustawWartosc] = useState(cel)
  const biezaca = useRef(cel)

  useEffect(() => {
    if (wolimyBezRuchu()) {
      biezaca.current = cel
      ustawWartosc(cel)
      return
    }

    const od = biezaca.current
    if (od === cel) return

    let klatka = 0
    const poczatek = performance.now()

    const krok = (teraz: number) => {
      const postep = Math.min((teraz - poczatek) / CZAS_MS, 1)
      const nowa = postep === 1 ? cel : Math.round(od + (cel - od) * wyhamuj(postep))
      biezaca.current = nowa
      ustawWartosc(nowa)
      if (postep < 1) klatka = requestAnimationFrame(krok)
    }

    klatka = requestAnimationFrame(krok)
    // Przerwana animacja zostawia bieżącą wartość jako punkt wyjścia kolejnej,
    // dzięki czemu szybkie zmiany pod rząd nie skaczą od dawno nieaktualnej liczby.
    return () => cancelAnimationFrame(klatka)
  }, [cel])

  return wartosc
}
